/**
 * Component for rendering the alternate Typography variants from the OR
 * style guide that are not supported by Material UI Typography
 */
import React from 'react';
import PropTypes from 'prop-types';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/styles';

const propTypes = {
  classes: PropTypes.shape({
    altTitle: PropTypes.string,
    altSubheading: PropTypes.string,
    colorTextPrimary: PropTypes.string,
  }).isRequired,
  variant: PropTypes.string,
};

const defaultProps = {
  variant: undefined,
};

export function UnstyledORTypography({ classes, variant, ...rest }) {
  const customClasses = { ...classes };
  delete customClasses.altTitle;
  delete customClasses.altSubheading;
  switch (variant) {
    case 'altTitle':
      return (
        <Typography variant="h6" classes={{ h6: classes.altTitle, ...customClasses }} {...rest} />
      );
    case 'altSubheading':
      return (
        <Typography
          variant="subtitle1"
          classes={{ subtitle1: classes.altSubheading, ...customClasses }}
          {...rest}
        />
      );
    default:
      return <Typography classes={customClasses} variant={variant} {...rest} />;
  }
}

UnstyledORTypography.propTypes = propTypes;
UnstyledORTypography.defaultProps = defaultProps;

const styles = (theme) => ({
  altTitle: theme.typography.altTitle,
  altSubheading: theme.typography.altSubheading,
  colorTextPrimary: null,
});

export default withStyles(styles)(UnstyledORTypography);
